export default __webpack_public_path__ + "static/media/Logistics.f4324496.png";